
import React, { Component } from 'react'
import './Home.css'
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
// import{category_list, doCategoryRes} from '../../action/categoryAction';
import { ProductFeature, doFeatureProductRes } from '../../action/FeatureProductAction';
import { ProductListing, doNewProductListingRes } from '../../action/NewProductListingAction';
import { menuCategory, doMenuCategoryRes } from '../../action/MenuCategoryAction';
import { bannerHomePage, doHomePageBannerRes } from '../../action/HomePageBannerAction';
import { subBannerHomePage, doHomePageSubBannerRes } from '../../action/HomePageSubBannerAction';
import { showAltText, doAltTextRes } from '../../action/AltTextAction';
import LayoutWrapper from '../../component/LayoutWrapper/'
import Footer from '../../component/Footer/Footer';
// import banner1 from '../../assets/images/banners/sb_banner-02.png';
// import banner2 from '../../assets/images/banners/banner-2.png';
// import banner3 from '../../assets/images/banners/banner-3.png';
// import banner4 from '../../assets/images/banners/banner-4.png';
import Carousel, { consts } from 'react-elastic-carousel'
import loaderImg from '../../assets/images/loader-example.gif';
import Loader from 'react-loader-advanced';

import ReactGA from 'react-ga';
import CookieConsent from "react-cookie-consent";
import ReactPixel from 'react-facebook-pixel';
import Skeleton from 'react-loading-skeleton';
// import {
// 	isAndroid,
// 	isIOS
//   } from "react-device-detect";
// import AppIcon from '../../assets/images/appIcon/app-icon.png';

const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 2 },
    { width: 768, itemsToShow: 4 },
    { width: 1200, itemsToShow: 4 }
];
const bannerBreakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 2 },
    { width: 768, itemsToShow: 2 },
    { width: 1200, itemsToShow: 3 },
];
class Home extends Component {
    constructor() {
        super();
        this.state = {
            categoryImageList: [],
            categoryImgUrl: [],
            featureProductSliderData: [],
            newProductListData: [],
            uiRender: false,
            featureSliderData: [],
            MenuCategorydata: [],
            isLoader: false,
            showBanner: true,
            bannerListFirst: '',
            bannerListSecond: '',
            bannerListThird: '',
            bannerListFourth: '',
            altData: '',
            bannerImageData: [],
            bannerSubData: [],
            dWidth: 550,
        }
        ReactGA.initialize('UA-64201999-5');
        ReactGA.pageview(window.location.pathname + window.location.search);

        ReactPixel.init('623085475428213');

        ReactPixel.pageView();
    }

    componentDidMount() {
        const data = {}
        const altData = {}
        const homebannerData = {}
        const homeSubBannerData = {}
        // this.props.category_list(data)
        const featureProductdata = {}
        const ProductListingdata = {}
        // const data = {}
        this.setState({
            isLoader: true
        })
        this.props.ProductFeature(featureProductdata)
        this.props.ProductListing(ProductListingdata)
        this.props.menuCategory(data)
        this.props.bannerHomePage(homebannerData)
        this.props.subBannerHomePage(homeSubBannerData)
        this.props.showAltText(altData)

    }

    componentWillReceiveProps(nextProps) {
        // console.log('next', nextProps)
        if (nextProps.doFeatureProductRes && nextProps.doFeatureProductRes.user) {
            if (nextProps.doFeatureProductRes.user && nextProps.doFeatureProductRes.user.FeatureProductRes) {
                if (nextProps.doFeatureProductRes.user.FeatureProductRes && nextProps.doFeatureProductRes.user.FeatureProductRes.results === true) {
                    this.setState({
                        featureProductSliderData: nextProps.doFeatureProductRes.user.FeatureProductRes.data,
                        isLoader: false
                    })
                } else {
                    this.setState({
                        isLoader: false
                    })
                }
            }
        }

        if (nextProps.doNewProductListingRes && nextProps.doNewProductListingRes.user) {
            if (nextProps.doNewProductListingRes.user && nextProps.doNewProductListingRes.user.NewProductListingRes) {
                if (nextProps.doNewProductListingRes.user.NewProductListingRes && nextProps.doNewProductListingRes.user.NewProductListingRes.results === true) {
                    this.setState({
                        newProductListData: nextProps.doNewProductListingRes.user.NewProductListingRes.data,
                        isLoader: false
                    })
                } else {
                    this.setState({
                        isLoader: false
                    })
                }
            }
        }

        if (nextProps.doMenuCategoryRes && nextProps.doMenuCategoryRes.user) {
            if (nextProps.doMenuCategoryRes.user && nextProps.doMenuCategoryRes.user.MenuCategoryRes) {
                if (nextProps.doMenuCategoryRes.user.MenuCategoryRes && nextProps.doMenuCategoryRes.user.MenuCategoryRes.result === true) {
                    this.setState({
                        MenuCategorydata: nextProps.doMenuCategoryRes.user.MenuCategoryRes.category,
                        isLoader: false
                    })

                } else {
                    this.setState({
                        isLoader: false
                    })
                }
            }
        }

        if (nextProps.doHomePageBannerRes && nextProps.doHomePageBannerRes.user) {
            if (nextProps.doHomePageBannerRes.user && nextProps.doHomePageBannerRes.user.HomePageBannerRes) {
                if (nextProps.doHomePageBannerRes.user.HomePageBannerRes && nextProps.doHomePageBannerRes.user.HomePageBannerRes.result === true) {

                    this.setState({
                        bannerImageData: nextProps.doHomePageBannerRes.user.HomePageBannerRes.bannerList,
                        // bannerListFirst: nextProps.doHomePageBannerRes.user.HomePageBannerRes.bannerList[0],
                        // bannerListSecond: nextProps.doHomePageBannerRes.user.HomePageBannerRes.bannerList[1],
                        // bannerListThird: nextProps.doHomePageBannerRes.user.HomePageBannerRes.bannerList[2],
                        // bannerListFourth: nextProps.doHomePageBannerRes.user.HomePageBannerRes.bannerList[3],
                    })
                }
            }
        }

        if (nextProps.doHomePageSubBannerRes && nextProps.doHomePageSubBannerRes.user) {
            if (nextProps.doHomePageSubBannerRes.user && nextProps.doHomePageSubBannerRes.user.HomePageSubBannerRes) {
                if (nextProps.doHomePageSubBannerRes.user.HomePageSubBannerRes && nextProps.doHomePageSubBannerRes.user.HomePageSubBannerRes.result === true) {
                    this.setState({
                        bannerSubData: nextProps.doHomePageSubBannerRes.user.HomePageSubBannerRes.bannerList
                    })
                }
            }
        }

        if (nextProps.doAltTextRes && nextProps.doAltTextRes.user) {
            if (nextProps.doAltTextRes.user && nextProps.doAltTextRes.user.AltTextRes) {
                if (nextProps.doAltTextRes.user.AltTextRes && nextProps.doAltTextRes.user.AltTextRes.result === true) {
                    this.setState({
                        altData: nextProps.doAltTextRes.user.AltTextRes.data
                    })
                }
            }
        }
    }


    productDetails = (item) => {
        if (item.product_type === "customize") {
            if (item.cat_name === "KEY CHAIN") {
                this.props.history.push('/productkeycustomize/' + item.product_id + '/' + item.slug, {
                    product_type: item.product_type,
                    product_id: item.product_id,
                    is_varient: item.is_varient
                })
            }
            if (item.cat_name === "MUG") {
                this.props.history.push('/productcupcustomize/' + item.product_id + '/' + item.slug, {
                    product_type: item.product_type,
                    product_id: item.product_id,
                    is_varient: item.is_varient
                })
            }
            if (item.sub_cat_id === "10") {
                window.location.href = '/productcustomize/1/' + item.sub_cat_id + '/' + item.slug
            }
            if (item.sub_cat_id === "14") {
                window.location.href = '/productmobilecustomize/3/' + item.sub_cat_id + '/' + item.slug
            }
            if (item.sub_cat_id === '11') {
                window.location.href = '/productwomencustomize/17/' + item.sub_cat_id + '/' + item.slug
            }
            if (item.sub_cat_id === '17') {
                window.location.href = '/productkidscustomize/20/' + item.sub_cat_id + '/' + item.slug
            }
            if (item.cat_name === "COMBOS") {
                window.location.href = '/product/21/' + item.sub_cat_id + '/' + item.slug
                this.props.history.push('/product/21/' + item.sub_cat_id + '/' + item.slug, {
                    sub_id: item.sub_cat_id,
                    cat_id: "21"
                })
            }


        } else if (item.product_type === "simple" || item.product_type === "Simple") {
            if (item.sub_cat_id === '345') {
                window.location.href = '/productcouplecombo/' + item.product_id + '/' + item.slug
                this.props.history.push('/productcouplecombo/' + item.product_id + '/' + item.slug, {
                    product_type: item.product_type,
                    product_id: item.product_id,
                    is_varient: item.is_varient,
                    slug: item.slug
                })
            } else if (item.cat_name === "MUG" && item.is_varient === "0") {
                window.location.href = '/product-mug-view/' + item.product_id + '/' + item.slug
                this.props.history.push({
                    pathname: `/product-mug-view/${item.product_id}/${item.slug}`,
                    state: item
                });
            } else {

                window.location.href = '/productview/' + item.product_id + '/' + item.slug + '?size=' + item.size + '&color=' + item.color.replace(" ", "+") + '&sleves=' + item.sleeve.replace(" ", "+")
                this.props.history.push('/productview/' + item.product_id + '/' + item.slug + '?size=' + item.size + '&color=' + item.color.replace(" ", "+") + '&sleves=' + item.sleeve.replace(" ", "+"), {
                    product_type: item.product_type,
                    product_id: item.product_id,
                    is_varient: item.is_varient,
                    sub_cat_id: item.sub_cat_id
                })
                // } else{
                //     window.location.href = '/productview/'+item.product_id+'/'+item.slug+'?size=M&color='+item.color+'&sleves=Full Sleeve'
                //     this.props.history.push('/productview/'+item.product_id+'/'+item.slug+'?size=M&color='+item.color+'&sleves=Full Sleeve', {
                //         product_type: item.product_type,
                //         product_id:item.product_id,
                //         is_varient: item.is_varient,
                //         sub_cat_id: item.sub_cat_id
                //     })
                // }
            }

        }

    }

    productCategory = (item) => {
        this.props.history.push('/menu-subcatrgory/' + item.id + '/' + item.slug, {
            productCategoryData: item
        })
    }

    productMobileDetails = () => {

        for (let menuItem of this.state.MenuCategorydata) {
            for (let imageItem of menuItem.sub_cat) {
                if (imageItem.sub_id === "14") {
                    window.location.href = '/productmobilecustomize/' + imageItem.cat_id + '/' + imageItem.sub_id + '/' + imageItem.slug
                }
            }
        }

    }

    productBannerDetails = (url) => {
        window.location.href = url
        // for(let menuItem of this.state.MenuCategorydata){
        //     for(let imageItem of menuItem.sub_cat){
        //         if(imageItem.sub_id === "343"){
        //             window.location.href = '/product/'+imageItem.cat_id+'/'+imageItem.sub_id+'/'+imageItem.slug
        //         }
        //     }
        // } 
    }

    productTshirtDetails = () => {
        for (let menuItem of this.state.MenuCategorydata) {
            for (let imageItem of menuItem.sub_cat) {
                if (imageItem.sub_id === "10") {
                    window.location.href = '/productcustomize/' + imageItem.cat_id + '/' + imageItem.sub_id + '/' + imageItem.slug
                }
            }
        }
    }

    productGraduationDetails = () => {
        for (let menuItem of this.state.MenuCategorydata) {
            for (let imageItem of menuItem.sub_cat) {
                // if(imageItem.sub_id === "10"){
                //     window.location.href = '/productcustomize/'+imageItem.slug
                // }
                if (imageItem.sub_id === "2") {
                    window.location.href = '/product/' + imageItem.cat_id + '/' + imageItem.sub_id + '/' + imageItem.slug
                    this.props.history.push('/product/' + imageItem.cat_id + '/' + imageItem.sub_id + '/' + imageItem.slug, {
                        sub_id: imageItem.sub_id,
                        cat_id: imageItem.cat_id
                    })
                }

            }
        }
    }

    // hideBanaer = () => {
    //     this.setState({
    //         showBanner: false,
    //     });
    // }

    myArrow({ type, onClick, isEdge }) {
        const pointer = type === consts.PREV ? '' : ''
        return (
            <button onClick={onClick} disabled={isEdge} className="btn-arrow-none">
                {pointer}
            </button>
        )
    }

    clickBaneerSlider = (index) => {
        window.location.href = this.state.bannerImageData[index].url
    }

    render() {
        const spinner = <span><img src={loaderImg} alt="" /></span>;
        // let rBtnCpnt = (<div className="btnWrapperStyle">
        //     <div className = "material-icons btnStyle" ><i className="fas fa-chevron-right right-left-color"></i></div>
        // </div>);

        // let lBtnCpnt = (<div className="btnWrapperStyle">
        //     <div className = "material-icons btnStyle" ><i className="fas fa-chevron-left right-left-color"></i></div>
        // </div>);


        return (
            <React.Fragment>
                <LayoutWrapper />
                <div className="page-wrapper">
                    {/* {
                        (isIOS) && 
                        <div>
                            {
                                (this.state.showBanner) &&
                                <div className="mysmartbannerios mysmartbanner-ios mysmartbanner-top">
                                    <div className="smartbanner-container">
                                        <button type="button" className="smartbanner-close" aria-label="close" onClick={this.hideBanaer}>×</button><span className="smartbanner-icon" style={{ backgroundImage: 'url(' + AppIcon + ')'}}></span>
                                        <div className="smartbanner-info">
                                            <div className="smartbanner-title">Stylecabbie - Your Style Driver</div>
                                            <div className="smartbanner-author"></div>
                                            <div className="smartbanner-description">Free - On the App Store</div>
                                        </div>
                                        <div className="smartbanner-wrapper"><a href="https://apps.apple.com/us/app/stylecabbie/id1510905562" className="smartbanner-button"><span className="smartbanner-button-text">View</span></a></div>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                    {
                        (isAndroid) && 
                        <div>
                            {
                                (this.state.showBanner) &&
                                <div className="mysmartbanner mysmartbanner-android mysmartbanner-top">
                                    <div className="smartbanner-container">
                                        <button type="button" className="smartbanner-close" aria-label="close" onClick={this.hideBanaer}>×</button><span className="smartbanner-icon" style={{ backgroundImage: 'url(' + AppIcon + ')'}}></span>
                                        <div className="smartbanner-info">
                                            <div className="smartbanner-title">Stylecabbie - Your Style Driver</div>
                                            <div className="smartbanner-author"></div>
                                            <div className="smartbanner-description">Free - In Google Play</div>
                                        </div>
                                        <div className="smartbanner-wrapper"><a href="https://play.google.com/store/apps/details?id=com.stylecabbie" className="smartbanner-button"><span className="smartbanner-button-text">View</span></a></div>
                                    </div>
                                </div>
                            }
                        </div>
                    }          */}
                    <CookieConsent
                        location="bottom"
                        buttonText="ALLOW COOKIES"
                        cookieName="myAwesomeCookieName2"
                        style={{ background: "#fff" }}
                        buttonStyle={{ color: "#fff", fontSize: "13px", padding: "15px", margin: "20px", marginRight: '250px', background: '#1b75bc' }}
                        expires={150}
                        className="cookie-btn-clr"
                    >
                        <div className="cookie-disply-margin">
                            <p className="cookie-p dis-cookie-flex">We use cookies to collect and analyse information on site performance and usage, to provide social media features and to enhance and customise content and advertisements. </p>
                            <span className="cookie-learn"><a href="https://www.cookiehub.com/about-cookies?en" rel="noopener" target="_self" className="cookie-learn">Learn more</a></span>
                        </div>
                    </CookieConsent>


                    <Loader show={this.state.isLoader} message={spinner}>

                        <main className="main main-container">
                            <div className="home-top-container">

                                <div className=" banner-image">
                                    <Carousel enableAutoPlay autoPlaySpeed={1000} focusOnSelect={true} itemsToShow={3} renderArrow={this.myArrow} breakPoints={bannerBreakPoints} pagination={false}>
                                        {
                                            this.state.bannerImageData && this.state.bannerImageData.map((item, i) => (
                                                item.slider ?
                                                    <div key={i} className="div-width" onClick={() => this.clickBaneerSlider(i)}>

                                                        {/* <img src={item.slider} className="image-width" alt={this.state.altData} /> */}

                                                        <div className="pointer banner-size " key={i} title={this.state.altData} aria-label={this.state.altData} style={{ backgroundImage: "url(" + item.slider + ")", backgroundSize: '100%', backgroundPosition: "center", backgroundRepeat: "no-repeat" }} name={item.name} onClick={() => this.clickBaneerSlider(i)}></div>
                                                    </div>
                                                    :
                                                    <Skeleton height={390} />
                                            ))
                                        }
                                    </Carousel>
                                </div>



                                {/* <div className="col-lg-5">
                                                <div className="banner banner-image">
                                                    {
                                                        this.state.bannerListFirst ?
                                                            <div className="pointer banner-size" title={this.state.altData} aria-label={this.state.altData} style={{ backgroundImage: "url(" + this.state.bannerListFirst.slider + ")", backgroundSize: '100%', backgroundPosition: "center", backgroundRepeat: "no-repeat" }} name={this.state.bannerListFirst && this.state.bannerListFirst.name} onClick={() => this.productBannerDetails(this.state.bannerListFirst && this.state.bannerListFirst.url)}></div>
                                                            :
                                                            <Skeleton height={600} />
                                                    }
                                                </div>
                                                </div>

                                                <div className="col-lg-7 top-banners">
                                                    <div className="row">
                                                        <div className="col-sm-6">

                                                            <div className="banner banner-image">
                                                                {this.state.bannerListSecond ?
                                                                    <div className="pointer banner-second-size" title={this.state.altData} aria-label={this.state.altData} style={{ backgroundImage: "url(" + this.state.bannerListSecond.slider + ")", backgroundSize: '100%', backgroundPosition: "center", backgroundRepeat: "no-repeat" }} name={this.state.bannerListSecond && this.state.bannerListSecond.name} onClick={() => this.productBannerDetails(this.state.bannerListSecond && this.state.bannerListSecond.url)}></div>
                                                                    :
                                                                    <Skeleton height={300} />
                                                                }
                                                            </div>

                                                            <div className="banner banner-image">
                                                                {this.state.bannerListThird ?
                                                                    <div className="pointer banner-second-size" title={this.state.altData} aria-label={this.state.altData} style={{ backgroundImage: "url(" + this.state.bannerListThird.slider + ")", backgroundSize: '100%', backgroundPosition: "center", backgroundRepeat: "no-repeat" }} name={this.state.bannerListThird && this.state.bannerListThird.name} onClick={() => this.productBannerDetails(this.state.bannerListThird && this.state.bannerListThird.url)}></div>
                                                                    :
                                                                    <Skeleton height={300} />
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6">
                                                            <div className="banner banner-image">
                                                                {this.state.bannerListFourth ?
                                                                    <div className="pointer banner-third-size" title={this.state.altData} aria-label={this.state.altData} style={{ backgroundImage: "url(" + this.state.bannerListFourth.slider + ")", backgroundSize: '100%', backgroundPosition: "center", backgroundRepeat: "no-repeat" }} name={this.state.bannerListFourth && this.state.bannerListFourth.name} onClick={() => this.productBannerDetails(this.state.bannerListFourth && this.state.bannerListFourth.url)}></div>

                                                                    :
                                                                    <Skeleton height={600} />}
                                                            </div>

                                                        </div>
                                                        

                                                    </div>

                                                </div> */}



                                {/* End .container */}
                            </div>
                            {/* End .home-top-container  */}

                            {/*Just */}
                            <div className="container">
                                <div className="widgetSliderWrapper">
                                    <ul>

                                        {
                                            this.state.bannerSubData && this.state.bannerSubData.map((item, j) => (
                                                <li key={j}>
                                                    <div className="widgetSliderInner" >
                                                        <div className='alte'>
                                                            <div className="widgetImg">
                                                                <img src={item.slider} className="img_height pointer" alt={this.state.altData} onClick={() => this.clickBaneerSlider(j)} />
                                                                {/* <div className="pointer banner-sub-size subImg" title={this.state.altData} aria-label={this.state.altData} style={{ backgroundImage: "url(" + item.slider + ")", backgroundSize: '100%', backgroundPosition: "center", backgroundRepeat: "no-repeat" }} name={item.name} onClick={() => this.clickBaneerSlider(j)}></div> */}
                                                            </div>
                                                            {/* <p>Design Of The Day</p> */}
                                                        </div>
                                                    </div>
                                                </li>
                                            ))
                                        }

                                        {/*<li>
                                            <div className="widgetSliderInner" >
                                                <div className='alte'>
                                                    <div className="widgetImg">
                                                        <img src="https://images.bewakoof.com/uploads/grid/app/tod-thumbnail-best-seller-1637307127.jpg" alt="Bestsellersimage" />
                                                    </div>
                                                    <p>Bestsellers</p>
                                                </div>
                                            </div>
                                        </li>
                                       <li>
                                            <div className="widgetSliderInner" >
                                                <div className='alte'>
                                                    <div className="widgetImg">
                                                        <img src="https://images.bewakoof.com/uploads/grid/app/vote-for-design-1641715844.jpg" alt="Vote for Designsimage" />
                                                    </div>
                                                    <p>Vote for Designs</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="widgetSliderInner" >
                                                <div className='alte'>
                                                    <div className="widgetImg">
                                                        <img src="https://images.bewakoof.com/uploads/grid/app/cotm-march-bottom-nav-1646408472.jpg" alt="Color of the Monthimage" />
                                                    </div>
                                                    <p>Color of the Month</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="widgetSliderInner" >
                                                <div className='alte'>
                                                    <div className="widgetImg">
                                                        <img src="https://images.bewakoof.com/uploads/grid/app/TheOfficialMerchStore-Thumbnail-1647328575.jpg" alt="The Official Merch Storeimage" />
                                                    </div>
                                                    <p>The Official Merch Store</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="widgetSliderInner" >
                                                <div className='alte'>
                                                    <div className="widgetImg">
                                                        <img src="https://images.bewakoof.com/uploads/grid/app/coke-x-bwkf-thumbnail--1--1645602489.jpg" alt="Coca Cola Collectionimage" />
                                                    </div>
                                                    <p>Coca Cola Collection</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="widgetSliderInner" >
                                                <div className='alte'>
                                                    <div className="widgetImg">
                                                        <img src="https://images.bewakoof.com/uploads/grid/app/CUSTOMISE-thumbnail-1644818150.jpg" alt="Customizationimage" />
                                                    </div>
                                                    <p>Customization</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="widgetSliderInner" >
                                                <div className='alte'>
                                                    <div className="widgetImg">
                                                        <img src="https://images.bewakoof.com/uploads/grid/app/tod-thumbnail-new-arrival-1637307130.jpg" alt="New Arrivalsimage" />
                                                    </div>
                                                    <p>New Arrivals</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="widgetSliderInner" >
                                                <div className='alte'>
                                                    <div className="widgetImg">
                                                        <img src="https://images.bewakoof.com/uploads/grid/app/tod-thumbnail-plus-size-1637307128.jpg" alt="Plus Sizeimage" />
                                                    </div>
                                                    <p>Plus Size</p>
                                                </div>
                                            </div>
                                        </li> */}

                                    </ul>
                                </div>
                            </div>

                            <div className="container arrived-products">
                                <h2 className="subtitle">
                                    <span>Just Arrived</span>
                                </h2>

                                <div className="row row-sm">


                                    <Carousel itemPadding={[10, 10]} itemsToShow={5} breakPoints={breakPoints} pagination={false}>
                                        {this.state.newProductListData && this.state.newProductListData.map((item, i) => (
                                            <div key={i}>
                                                <div className="product-default inner-quickview inner-icon inner-icon-inline inner-btn">

                                                    <div className="img-child">
                                                        <figure>
                                                            <div className="pointer img-wdth img-height img-just" title={this.state.altData} aria-label={this.state.altData} onClick={() => this.productDetails(item)} style={{ "backgroundImage": 'url(' + item.photo + ')', backgroundSize: '100%', backgroundPosition: "center", backgroundRepeat: "no-repeat" }} />
                                                        </figure>
                                                    </div>

                                                    <div className="product-details text-center">
                                                        <h2 className="product-title">
                                                            <span className="product-name pointer " onClick={() => this.productDetails(item)}>{item.name}</span>
                                                        </h2>
                                                        <div className="price-box">
                                                            <span className="old-price"><i className="fa fa-rupee-sign" aria-hidden="true"></i>{item.price}.00</span>

                                                            <span className="product-price"><i className="fa fa-rupee-sign" aria-hidden="true"></i>{item.sale_price}.00</span>
                                                        </div>
                                                        <button className="btn btn-primary text-white show-color" data-toggle="modal" data-target="#addCartModal" onClick={() => this.productDetails(item)}>Show Details</button>
                                                        {/* End .price-box  */}
                                                    </div>
                                                    {/* End .product-details */}
                                                </div>
                                            </div>
                                        ))}

                                    </Carousel>
                                    {/* End .col-xl-2 */}


                                </div>
                            </div>

                            <div className="mb-5"></div>
                            {/* margin  */}
                            <div className="banners-section">
                                <div className="container">
                                    <h2 className="subtitle text-center"><span>BROWSE OUR CATEGORIES</span></h2>

                                    <div className="cats-carousel  owl-theme">
                                        <div className="banner banner-image bg-color-cate row row-sm">
                                            <Carousel itemPadding={[10, 10]} itemsToShow={5} breakPoints={breakPoints} pagination={false}>
                                                {this.state.MenuCategorydata && this.state.MenuCategorydata.map((item, i) => (
                                                    <div key={i}>
                                                        <div className="product-default inner-quickview inner-icon inner-icon-inline inner-btn">
                                                            {/* <figure> */}
                                                            <div className="pointer img-wdth img-height" title={this.state.altData} aria-label={this.state.altData} onClick={() => this.productCategory(item)} style={{ "backgroundImage": 'url(' + item.image + ')', backgroundSize: '100%', backgroundPosition: "center", backgroundRepeat: "no-repeat" }} />
                                                            {/* </figure> */}
                                                            <div className="product-details text-center cat-name top-pd-title">
                                                                <h2 className="product-title">
                                                                    <span className="product-name pointer item-name " onClick={() => this.productCategory(item)}>{item.cat_name}</span>
                                                                </h2>

                                                            </div>
                                                            {/* End .product-details */}
                                                        </div>
                                                    </div>
                                                ))}

                                            </Carousel>
                                        </div>
                                    </div>
                                </div>
                                {/* End .container  */}
                            </div>
                            {/* End .banners-section  */}
                            <div className="mb-5"></div>
                            {/* margin */}

                            {/*featured */}

                            <div className="container">
                                <h2 className="subtitle">
                                    <span>Featured Products</span>
                                </h2>

                                <div className="featured-products  owl-theme row row-sm">

                                    <Carousel itemPadding={[10, 10]} itemsToShow={5} breakPoints={breakPoints} pagination={false}>
                                        {/* enableAutoPlay autoPlaySpeed={1500} infinite */}
                                        {this.state.featureProductSliderData && this.state.featureProductSliderData.map((item, i) => (
                                            <div key={i}>
                                                <div className="product-default inner-quickview inner-icon inner-icon-inline inner-btn">
                                                    <div className="img-child">
                                                        <figure>
                                                            <div className="pointer img-wdth img-height img-just" title={this.state.altData} aria-label={this.state.altData} onClick={() => this.productDetails(item)} style={{ "backgroundImage": 'url(' + item.photo + ')', backgroundSize: '100%', backgroundPosition: "center", backgroundRepeat: "no-repeat" }} />
                                                        </figure>
                                                    </div>
                                                    <div className="product-details text-center">
                                                        <h2 className="product-title">
                                                            <span className="product-name pointer" onClick={() => this.productDetails(item)}>{item.name}</span>
                                                        </h2>
                                                        <div className="price-box">
                                                            <span className="old-price"><i className="fa fa-rupee-sign" aria-hidden="true"></i>{item.price}.00</span>

                                                            <span className="product-price"><i className="fa fa-rupee-sign" aria-hidden="true"></i>{item.sale_price}.00</span>
                                                        </div>
                                                        <button className="btn btn-primary text-white show-color detais-btn" data-toggle="modal" data-target="#addCartModal" onClick={() => this.productDetails(item)}>Show Details</button>
                                                        {/* End .price-box  */}
                                                    </div>
                                                    {/* End .product-details */}
                                                </div>
                                            </div>
                                        ))}

                                    </Carousel>






                                </div>
                                {/* End .featured-products */}
                            </div>
                            {/* End .container */}


                        </main>
                        {/* End .main */}
                    </Loader>


                </div>
                <Footer />
            </React.Fragment>
        )
    }
}

Home.propTypes = {
    doFeatureProductRes: PropTypes.any,
    doNewProductListingRes: PropTypes.any,
    doMenuCategoryRes: PropTypes.any,
    doHomePageBannerRes: PropTypes.any,
    doAltTextRes: PropTypes.any,
    doHomePageSubBannerRes: PropTypes.any,
};

const mapStateToProps = createStructuredSelector({
    doFeatureProductRes: doFeatureProductRes,
    doNewProductListingRes: doNewProductListingRes,
    doMenuCategoryRes: doMenuCategoryRes,
    doHomePageBannerRes: doHomePageBannerRes,
    doAltTextRes: doAltTextRes,
    doHomePageSubBannerRes: doHomePageSubBannerRes,
});

function mapDispatchToProps(dispatch) {
    return {
        ProductFeature: (data) => dispatch(ProductFeature(data)),
        ProductListing: (data) => dispatch(ProductListing(data)),
        menuCategory: (data) => dispatch(menuCategory(data)),
        bannerHomePage: (data) => dispatch(bannerHomePage(data)),
        showAltText: (data) => dispatch(showAltText(data)),
        subBannerHomePage: (data) => dispatch(subBannerHomePage(data)),
    };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(Home) 
